import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Link } from "react-router-dom";
import { teachersApi } from "../../services/teachers/teachersApi";
import Error from "../../components/common/Error";
import { Skeleton } from "primereact/skeleton";
import { useEffect, useRef, useState } from "react";
import { DataTable } from "../../components/data/DataTable";
import { Column } from "primereact/column";
import { TeacherResponse } from "../../models/dtos";
import { ConfirmPopup } from "primereact/confirmpopup";
import { Toast } from "primereact/toast";
import { useSelector } from "react-redux";
import { getDepartmentsFilters, getFacultiesFilters } from "../../services/teachers/teachersSlice";
import { useAppDispatch } from "../../hooks/redux";
import { setContextSidebar } from "../../services/base/layoutSlice";

const TeachersList = () => {
  const departmentsFilters = useSelector(getDepartmentsFilters);
  const facultiesFilters = useSelector(getFacultiesFilters);
  
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setContextSidebar(true));

    return () => {
      dispatch(setContextSidebar(false));
    };
  }, [dispatch]);

  const { data: teachers, error, isLoading, isFetching, refetch } = teachersApi.useGetTeachersQuery({
    byDepartment: departmentsFilters.departments.map((x) => ({
      id: x.departmentId
    })),
    byFaculty: facultiesFilters.map((x) => ({
      id: x.facultyId
    }))
  });

  const [_loading, _setLoading] = useState(false);
  const toast = useRef<Toast>(null);
  const dt = useRef<any>(null);

  const [_deleteTeacher] = teachersApi.useDeleteTeacherMutation();

  const handleExport = () => {
    if (dt.current) {
      dt.current.exportCSV({ selectionOnly: true });
    }
  };

  const teacherTemplate = (rowData: TeacherResponse) => {
    return (
      <div className="flex align-items-center">
        <Link to={`/teachers/${rowData.teacherId}`}>
          <Button icon="pi pi-user"></Button>
        </Link>
      </div>
    );
  };

  const topButtons = (
    <div className="flex flex-row gap-2">
      <Link to="/teachers/create">
        <Button label="Добавяне на преподавател" icon="pi pi-plus" severity="secondary" />
      </Link>
      <Button label="Обновяване" icon="pi pi-refresh" severity="info" onClick={refetch} />
    </div>
  );

  const extraButtons = (
    <>
      <Button label="Експорт CSV" icon="pi pi-upload" severity="secondary" onClick={handleExport} />
    </>
  );

  if (isLoading || isFetching) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Error error={error} />;

  return (
    <div>
      <h1 className="mb-4 mt-0 text-4xl font-light">Преподаватели</h1>
      <Toolbar start={topButtons} end={extraButtons} />
      <ConfirmPopup />
      <Toast ref={toast} />
      <DataTable ref={dt} value={teachers?.data ?? []} emptyMessage="Не бяха открити преподаватели">
        <Column field="teacherId" header="ID" body={teacherTemplate} sortable filter></Column>
        <Column field="teacherNumber" header="Номер на преподавател" sortable filter></Column>
        <Column field="firstName" header="Име" sortable filter></Column>
        <Column field="middleName" header="Презиме" sortable filter></Column>
        <Column field="lastName" header="Фамилия" sortable filter></Column>
        <Column field="academicPositionShortName" header="Длъжност" sortable filter></Column>
        <Column field="academicRankShortName" header="Степен" sortable filter></Column>
        <Column field="departmentFacultyShortName" header="Факултет" sortable filter></Column>
        <Column field="departmentName" header="Катедра" sortable filter></Column>
      </DataTable>
    </div>
  );
};

export default TeachersList;
